import { getBikeFitment } from 'app/product/utils/getBikeFitment';
import { useBikeFilter } from 'context/BikeFilterContext';
import { CheckIcon } from 'lucide-react';
import type { ProductDocument } from 'models/product';
import type { UserBike } from 'models/shared';
import type { UserDocument } from 'models/user';

type ProductFitmentProps = {
  product: ProductDocument;
  userDoc: UserDocument | null | undefined;
};

export default function ProductFitment({ ...props }: ProductFitmentProps) {
  const isBikePart = props.product.category.toLowerCase().includes('parts');

  const { selectedBike } = useBikeFilter();

  if (!isBikePart) {
    return null;
  }

  const filteredBikes: UserBike[] =
    props.userDoc?.bikes ??
    (selectedBike.type ? [selectedBike as UserBike] : []);

  const fitment = getBikeFitment(
    props.product?.fitting_bikes?.bikes ?? [],
    filteredBikes,
    !!props.product.integration_info
  );

  if (fitment.status !== 'fits') return null;

  return (
    <div className="flex items-center gap-2 font-medium text-[#1E7A1E]">
      <div className="h-6 w-6 rounded-full bg-[#1E7A1E] p-1">
        <CheckIcon className="h-full w-full text-white" />
      </div>
      Fits your vehicle
    </div>
  );
}
